// Global constants for the application

// Supported US payment gateways
export const SUPPORTED_US_PG_LIST = ["FORTIS", "TSYS", "SHIFT4", "STRIPE", "ELAVON", "FREEDOMPAY"];
